module.exports = __webpack_public_path__ + "img/benfica.ba2db27e.png";